import type { Theme } from "@mui/material/styles";
import type { AppSx } from "../types";

export interface ErrorModalComponentStyles {
  modalBox: AppSx;
  description: AppSx;
  closeButton: AppSx;
}

export function buildErrorModalComponentStyles(_theme: Theme): ErrorModalComponentStyles {
  return {
    modalBox: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 400,
      bgcolor: "background.paper",
      border: "2px solid #2c3e50",
      boxShadow: 24,
      p: 4,
    },
    description: { mt: 2 },
    closeButton: { mt: 2 },
  };
}
